// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @commons
const ModalAbort = require('components/commons/modalAbort/modalAbort');
const { formatText } = require('core/i18n').i18n;

// @ constants
const { HIRE_VALUES_CONTRACT_URL } = require('constants/index');

// @actions
const brokerNoStockAccountModalActions = require('actions/brokerNoStockAccountModal');

class BrokerNoStockAccountModal  extends React.Component {

    constructor(props) {
        super(props);

        this.handleAcceptModal = this.handleAcceptModal.bind(this);
        this.handleCancelModal = this.handleCancelModal.bind(this);
    }

    handleAcceptModal() {
        this.props.hideModal();
        this.props.history.push(HIRE_VALUES_CONTRACT_URL);
    }

    handleCancelModal() {
        this.props.hideModal();
    }

    render() {
        const { immBrokerNoStockAccountModal } = this.props;
        const titleText = formatText("broker-broker_SearchResultmodalText");
        const titleKey = (
            <div>
                <i className="broker-search-results__warning-icon"></i>
                <p className="broker-search-results__text">{titleText}</p>
            </div>
        );

        return (
            <ModalAbort
                titleKey={titleKey}
                textKey=""
                isOpen={immBrokerNoStockAccountModal.get('isOpen')}
                onCancel={this.handleCancelModal}
                onAccept={this.handleAcceptModal}
            />);
    }
}

BrokerNoStockAccountModal .propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerNoStockAccountModal: PropTypes.object.isRequired,
    hideModal: PropTypes.func
};

module.exports.constructor = BrokerNoStockAccountModal;
module.exports.BrokerNoStockAccountModal = connect(
    state => ({
        immBrokerNoStockAccountModal: state.brokerNoStockAccountModal
    }),{
        hideModal: brokerNoStockAccountModalActions.hideModal
    }
)(withRouter(BrokerNoStockAccountModal));
